import React, { Component } from "react";
import { Redirect, withRouter } from "react-router-dom";
import PropTypes from "prop-types";
import axios from "axios";
import OlMap from "ol/Map";
import OlView from "ol/View";
import {
  Tile as TileLayer,
  Vector as VectorLayer,
  Image as ImageLayer
} from "ol/layer";
import {
  Cluster,
  OSM,
  XYZ,
  Vector as VectorSource,
  ImageArcGISRest,
  TileWMS,
  TileArcGISRest
} from "ol/source";
import Draw from "ol/interaction/Draw";
import { LineString, Polygon, Circle } from "ol/geom.js";
import { getLength } from "ol/sphere.js";
import { GeoJSON, Polyline } from "ol/format";
import Overlay from "ol/Overlay.js";
import Point from "ol/geom/Point.js";
import Feature from "ol/Feature.js";
import { connect } from "react-redux";
import MousePositionInfo from "../../granular/Portal/mousepositioninfo";
//import circleToPolygon from "circle-to-polygon";
import ImageWMS from "ol/source/ImageWMS";
//import * as render from "ol/render";

// import component
import Legend from "../../granular/Portal/legend";
import LegendLayer from "../../granular/Portal/legendLayer";
import PoiPopup from "../../granular/Portal/poipopup";
import icon_target from "../../assets/legend/target.png";
import moment from "moment";

import styles from "assets/jss/material-dashboard-pro-react/modalStyle";
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Close from "@material-ui/icons/Close";
import Button from "components/CustomButtons/Button.jsx";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";

// import api
import {
  fetchPOI,
  fetchVesselnew,
  fetchVesselPtm,
  fetchVesselPtmSourcex,
  fetchVesselPtmSourcexy,
  fetchWeather,
  fetchWeatherIndo,
  fetchTrackFraudApproach
} from "../../api/portal";

import {
  defaults as defaultControls,
  ScaleLine,
  OverviewMap
} from "ol/control.js";
import {
  defaults as defaultInteractions,
  DragRotateAndZoom
} from "ol/interaction.js";
import { fromLonLat, toLonLat, transform } from "ol/proj.js";
import {
  getTopRight,
  getBottomRight,
  getTopLeft,
  getBottomLeft
} from "ol/extent.js";
import _ from "lodash";
import {
  Circle as CircleStyle,
  Fill,
  Stroke,
  Icon,
  Style,
  Text,
  RegularShape
} from "ol/style.js";

import { pushLoader } from "../../actions/main";

import {
  pushShipFinder,
  pushPoiPasenger,
  pushPoiContent,
  pushLonlatMouse,
  pushDrawData,
  pushDrawDataAll,
  pushRadiusGeom,
  pushPoiSelected,
  pushZonaTarget,
  pushActiveDrawing,
  pushVesselPtmSelected,
  pushPoiTarget,
  pushPortTarget,
  pushPointShipTrack,
  pushAllStateMapmaster,
  pushShipTrack,
  pushShipTrack2,
  pushVesselPointTrack,
  pushShipFraud,
  pushSpeedTarget
} from "../../actions/portal";

import { pushRightPanel } from "../../actions/dashboard";

var formatLength = function(line) {
  var length = getLength(line);
  var output;
  if (length > 100) {
    output = Math.round((length / 1000) * 100) / 100 + " " + "km";
  } else {
    output = Math.round(length * 100) / 100 + " " + "m";
  }
  return output;
};

class Mapmaster extends Component {
  constructor(props) {
    super(props);
    const { center, zoom } = this.props;
    this.state = {
      oauth: localStorage.getItem("oauth"),
      drawType: "Point",
      features: [],
      opened: false,
      baloonTitle: "",
      zoom: zoom,
      center: center,
      vesselSelected: [],
      vesselData: [],
      vesselDataPtm: [],
      poiData: [],
      marker_vessel: [],
      marker_vessel_ptm: [],
      marker_poi: [],
      marker_weather: [],
      marker_bathymetry: [],
      searchPOI: null,
      searchPORT: null,
      searchSpeed: null,
      vesselTrack: null,
      searchFraud: null,
      layerMQ: null,
      zoneTarget: [],
      marker_poiGempa: [],
      speed: "",
      layerLines: "",
      poi_centerline: null,
      track_centerline: null,
      weatherIndo: [],
      openWmsInfo: false,
      openBathymetry: false,
      wmsInfo: [],
      bathymetry: []
    };

    this.drawTemp = [];
    this.vectorTemp = [];
  }

  createUrl(tpl, layerDesc) {
    return tpl
      .replace("{base}", layerDesc.base)
      .replace("{type}", layerDesc.type)
      .replace("{scheme}", layerDesc.scheme);
  }

  componentWillMount() {
    // left top panel map control
    const scaleLineControl = new ScaleLine({
      units: "metric",
      bar: true,
      steps: 4,
      text: true,
      minWidth: 140
    });
    const overviewMapControl = new OverviewMap({
      className: "ol-overviewmap ol-custom-overviewmap",
      layers: [
        new TileLayer({
          source: new OSM()
        })
      ],
      collapseLabel: "\u00BB",
      label: "\u00AB",
      collapsed: true
    });
    // end left top panel map control

    //create initial map
    this.olmap = new OlMap({
      controls: defaultControls().extend([
        overviewMapControl,
        scaleLineControl
      ]),
      interactions: defaultInteractions().extend([new DragRotateAndZoom()]),
      target: null,
      view: new OlView({
        center: fromLonLat(this.state.center),
        zoom: this.state.zoom,
        minZoom: 3,
        maxZoom: 20
      })
    });

    // var layerOSMx = new TileLayer({
    //   source: new OSM()
    // });

    var layerOSMx = new TileLayer({
      source: new XYZ({
        attributions:
          'Tiles © <a href="https://basemap.nationalmap.gov/ArcGIS/' +
          'rest/services/USGSTopo/MapServer">ArcGIS</a>',
        url: "https://tile.openstreetmap.de/{z}/{x}/{y}.png"
      })
    });
    this.setState({ layerOSM: layerOSMx });

    this.olmap.addLayer(layerOSMx);

    fetchVesselPtmSourcexy(this.props.sourceAis)
      .then(response => {
        this.setState({ vesselDataPtm: response.data.results });
        //const newdata = { val: "port", checked: false, icon_path: "port.png" };
        this.props.pushVesselPtmSelected(false);
        this.props.pushVesselPtmSelected(true);
        //this.props.pushPoiSelected([newdata]);
      })
      .catch(error => {
        console.log(error);
        localStorage.clear();

        if (this.state.oauth == "") {
          return <Redirect to={"/pages/login"} />;
        } else {
          // window.open("https://identity.idaman.pertamina.com/logout");
          return <Redirect to={"/pages/login"} />;
        }
      });
  }

  tick() {
    if (this.props.shipTrack.length < 1) {
      this.props.pushLoader(true);
      fetchVesselPtmSourcexy(this.props.sourceAis)
        .then(response => {
          this.setState({ vesselDataPtm: response.data.results });
          this.props.pushVesselPtmSelected(false);
          this.props.pushVesselPtmSelected(true);
          this.props.pushLoader(false);
        })
        .catch(error => {
          console.log(error);
          localStorage.clear();
          if (this.state.oauth == "") {
            return <Redirect to={"/pages/login"} />;
          } else {
            // window.open("https://identity.idaman.pertamina.com/logout");
            return <Redirect to={"/pages/login"} />;
          }
        });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    //load vessel type
    if (nextProps.filter == false) {
      fetchVesselnew()
        .then(response => {
          this.setState({ vesselData: response.data.results });
        })
        .catch(error => {
          console.log(error);
          // this.props.history.push("/pages/login#logout");
        });
    }

    //target focusing

    if (nextProps.poiTarget[1] != 0) {
      this.olmap.setView(
        new OlView({
          center: fromLonLat([
            parseFloat(nextProps.poiTarget[1]),
            parseFloat(nextProps.poiTarget[0])
          ]),
          zoom: 12
        })
      );
    }

    if (nextProps.portTarget[1] != 0) {
      this.olmap.setView(
        new OlView({
          center: fromLonLat([
            parseFloat(nextProps.portTarget[1]),
            parseFloat(nextProps.portTarget[0])
          ]),
          zoom: 12
        })
      );
    }

    if (nextProps.speedTarget[1] != 0) {
      this.olmap.setView(
        new OlView({
          center: fromLonLat([
            parseFloat(nextProps.speedTarget[1]),
            parseFloat(nextProps.speedTarget[0])
          ]),
          zoom: 12
        })
      );
    }

    if (nextProps.shipFraud[1] != 0) {
      this.olmap.setView(
        new OlView({
          center: fromLonLat([
            parseFloat(nextProps.shipFraud[1]),
            parseFloat(nextProps.shipFraud[0])
          ]),
          zoom: 12
        })
      );
    }

    // if (nextProps.vesselPointTrack[1] != 0) {
    //   this.olmap.setView(
    //     new OlView({
    //       center: fromLonLat([
    //         parseFloat(nextProps.vesselPointTrack[1]),
    //         parseFloat(nextProps.vesselPointTrack[0])
    //       ]),
    //       zoom: 12
    //     })
    //   );
    // }

    //target focusing

    //basemapAsli

    if (nextProps.basemapAsli === "OSM") {
      if (nextProps.basemapAsli !== this.props.basemapAsli) {
        this.olmap.removeLayer(this.state.layerOSM);

        // var layerOSMx = new TileLayer({
        //   source: new OSM()
        // });

        var layerOSMx = new TileLayer({
          source: new XYZ({
            attributions:
              'Tiles © <a href="https://basemap.nationalmap.gov/ArcGIS/' +
              'rest/services/USGSTopo/MapServer">ArcGIS</a>',
            url: "https://tile.openstreetmap.de/{z}/{x}/{y}.png"
          })
        });
        this.setState({ layerOSM: layerOSMx });

        this.olmap.addLayer(layerOSMx);
        layerOSMx.setZIndex(0);
      }
    } else {
      if (nextProps.basemapAsli !== this.props.basemapAsli) {
        this.olmap.removeLayer(this.state.layerOSM);
      }

      let urlTpl =
        "https://api.maptiler.com/maps/hybrid/{z}/{x}/{y}.jpg?key=2C76h5vrBAP7k7nDcWgn";
      //let urlTpl = "https://api.maptiler.com/tiles/terrain-quantized-mesh/{z}/{x}/{y}.quantized-mesh-1.0?key=2C76h5vrBAP7k7nDcWgn";
      const layerDesc = {
        base: "aerial",
        type: "maptile",
        scheme: "satellite.day"
      };

      var raster = new TileLayer({
        source: new XYZ({
          url: this.createUrl(urlTpl, layerDesc),
          attributions:
            "Tiles &copy; Esri &mdash; Source: Esri, i-cubed, USDA, USGS, " +
            "AEX, GeoEye, Getmapping, Aerogrid, IGN, IGP, UPR-EGP, and the GIS User Community"
        })
      });

      this.setState({ layerOSM: raster });

      this.olmap.addLayer(raster);
      raster.setZIndex(0);
    }
    //end basemapAsli

    //speed alert target
    if (this.state.searchSpeed !== null) {
      this.olmap.removeLayer(this.state.searchSpeed);
    }
    if (nextProps.speedTarget[1] !== 0) {
      this.icon_search_speed = new Style({
        image: new Icon({
          opacity: 1,
          src: icon_target,
          scale: 0.1
        })
      });
      let speedsearch = [];
      speedsearch.push(
        new Feature({
          geometry: new Point(
            fromLonLat([
              parseFloat(nextProps.speedTarget[1]),
              parseFloat(nextProps.speedTarget[0])
            ])
          ),
          name: "asd",
          jenis: "pointvessel"
        })
      );
      this.vectorSourceSpeedSearch = new VectorSource({
        features: speedsearch
      });
      this.markerVectorLayer_speedsearch = new VectorLayer({
        source: this.vectorSourceSpeedSearch,
        style: this.icon_search_speed
      });
      this.olmap.addLayer(this.markerVectorLayer_speedsearch);
      this.setState({ searchSpeed: this.markerVectorLayer_speedsearch });
      this.olmap.removeLayer(this.state.searchSpeed);
    }
    //end speed alert

    //vessel search
    if (this.state.searchPOI !== null) {
      this.olmap.removeLayer(this.state.searchPOI);
    }
    if (nextProps.poiTarget[1] !== 0) {
      if (nextProps.poiTarget.length > 2) {
        let vesselSearch = [];
        vesselSearch.push(
          new Feature({
            geometry: new Point(
              fromLonLat([
                parseFloat(nextProps.poiTarget[1]),
                parseFloat(nextProps.poiTarget[0])
              ])
            ),
            name: nextProps.poiTarget[2],
            hdg: nextProps.poiTarget[3],
            typenya: nextProps.poiTarget[4],
            geomtype: "vessel",
            course: nextProps.poiTarget[5],
            elapsed: nextProps.poiTarget[6],
            heading: nextProps.poiTarget[3],
            lat: nextProps.poiTarget[1],
            lon: nextProps.poiTarget[0],
            shipname: nextProps.poiTarget[2],
            shiptype: nextProps.poiTarget[4],
            ship_id: nextProps.poiTarget[7],
            speed: nextProps.poiTarget[8] * 0.1,
            destination: nextProps.poiTarget[9],
            width: nextProps.poiTarget[10],
            length: nextProps.poiTarget[11],
            dwt: nextProps.poiTarget[12],
            call_sign: "",
            rot: nextProps.poiTarget[13],
            flag: nextProps.poiTarget[14],
            date_created: nextProps.poiTarget[15],
            status_name: nextProps.poiTarget[16],
            type_img: nextProps.poiTarget[17],
            type_name: nextProps.poiTarget[18]
          })
        );
        this.vectorVesselSearch = new VectorSource({
          features: vesselSearch
        });

        var vesselSearch_style = {};

        this.markerVesselSearch = new VectorLayer({
          source: this.vectorVesselSearch,
          style: function(feature) {
            var style = vesselSearch_style;
            if (
              feature.get("hdg") == null ||
              feature.get("hdg") == "None" ||
              feature.get("hdg") == "null"
            ) {
              style = new Style({
                image: new Icon({
                  opacity: 1,
                  src: require(`../../assets/poi/${feature.get(
                    "typenya"
                  )}.png`),
                  scale: 0.1,
                  rotation: parseFloat(feature.get("course")) * 0.01745329251,
                  rotateWithView: "true"
                })
              });
            } else {
              style = new Style({
                image: new Icon({
                  opacity: 1,
                  src: require(`../../assets/poi/${feature.get(
                    "typenya"
                  )}.png`),
                  scale: 0.1,
                  rotation: parseFloat(feature.get("hdg")) * 0.01745329251,
                  rotateWithView: "true"
                })
              });
            }

            return style;
          }
        });

        this.olmap.addLayer(this.markerVesselSearch);
        this.markerVesselSearch.setZIndex(3);
        this.setState({ vessel_search: this.markerVesselSearch });
      }

      this.iconStyle_icon_search = new Style({
        image: new Icon({
          opacity: 1,
          src: icon_target,
          scale: 0.1
        })
      });
      let poisearch = [];
      poisearch.push(
        new Feature({
          geometry: new Point(
            fromLonLat([
              parseFloat(nextProps.poiTarget[1]),
              parseFloat(nextProps.poiTarget[0])
            ])
          ),
          name: "asd",
          jenis: "pointvessel"
        })
      );
      this.vectorSourcePoiSearch = new VectorSource({
        features: poisearch
      });
      this.markerVectorLayer_poisearch = new VectorLayer({
        source: this.vectorSourcePoiSearch,
        style: this.iconStyle_icon_search
      });
      this.olmap.addLayer(this.markerVectorLayer_poisearch);
      this.setState({ searchPOI: this.markerVectorLayer_poisearch });
      // tanda
      // if (nextProps.poiTarget[1] !== this.props.poiTarget[1]) {
      //   this.olmap.setView(
      //     new OlView({
      //       center: fromLonLat([
      //         parseFloat(nextProps.poiTarget[1]),
      //         parseFloat(nextProps.poiTarget[0])
      //       ]),
      //       zoom: 15
      //     })
      //   );
      // }
      this.olmap.removeLayer(this.state.searchPOI);
    }
    //end vessel search

    //ship fraud
    if (this.state.searchFraud !== null) {
      this.olmap.removeLayer(this.state.searchFraud);
    }
    if (nextProps.shipFraud[1] !== 0) {
      if (nextProps.shipFraud.length > 2) {
        fetchTrackFraudApproach(nextProps.shipFraud[4])
          .then(response => {

            let dataShipApp = [];

            response.data.results.map(e => {
              dataShipApp.push(
                new Feature({
                  geometry: new Point(
                    fromLonLat([
                      parseFloat(e.longitude),
                      parseFloat(e.latitude)
                    ])
                  ),
                  lat: e.latitude,
                  lon: e.longitude,
                  ship_id: e.shipid,
                  shipname: e.name,
                  name: e.name,
                  fraudid: e.fraud_id,
                  geomtype: "fraud",
                  date_created: moment(e.dateCreated)
                    .subtract(7, "hours")
                    .format("DD-MM-YYYY HH:mm:ss"),
                  speed: e.speed,
                  shiptype: e.shiptype
                })
              );
            });

            this.vectorShipApp = new VectorSource({
              features: dataShipApp
            });

            var shipFraudApp_style = {};

            this.markerShipFraudApp = new VectorLayer({
              source: this.vectorShipApp,
              style: function(feature) {
                var style = shipFraudApp_style;

                style = new Style({
                  image: new CircleStyle({
                    radius: 3,
                    fill: new Fill({ color: "#f00e0e" }),
                    stroke: new Stroke({
                      color: "red",
                      width: 1
                    })
                  }),
                  text: new Text({
                    text: feature.get("shipname"),
                    font: "12px Calibri,sans-serif",
                    fill: new Fill({
                      color: "#000"
                    }),
                    offsetY: -20,
                    stroke: new Stroke({
                      color: "#D4BE6A",
                      width: 3
                    })
                  })
                });

                return style;
              }
            });

            this.olmap.addLayer(this.markerShipFraudApp);
            this.markerShipFraudApp.setZIndex(3);
            this.setState({ fraudApp: this.markerShipFraudApp });
          })
          .catch(error => {
            console.log(error);
            // this.props.history.push("/pages/login#logout");
          });

        let shipFraudSearch = [];
        shipFraudSearch.push(
          new Feature({
            geometry: new Point(
              fromLonLat([
                parseFloat(nextProps.shipFraud[1]),
                parseFloat(nextProps.shipFraud[0])
              ])
            ),
            lat: nextProps.shipFraud[0],
            lon: nextProps.shipFraud[1],
            ship_id: nextProps.shipFraud[2],
            shipname: nextProps.shipFraud[3],
            name: nextProps.shipFraud[3],
            fraudid: nextProps.shipFraud[4],
            geomtype: "fraud",
            date_created: moment(nextProps.shipFraud[5])
              .subtract(7, "hours")
              .format("DD-MM-YYYY HH:mm:ss"),
            idleTime: nextProps.shipFraud[6],
            last_gps: moment(nextProps.shipFraud[7])
              .subtract(7, "hours")
              .format("DD-MM-YYYY HH:mm:ss"),
            last_ais: moment(nextProps.shipFraud[8])
              .subtract(7, "hours")
              .format("DD-MM-YYYY HH:mm:ss"),
            last_cctv: nextProps.shipFraud[9],
            speed: nextProps.shipFraud[10],
            weatherFraud: nextProps.shipFraud[11],
            windSpeedFraud: nextProps.shipFraud[12],
            first_recorded: moment(nextProps.shipFraud[13])
              .subtract(7, "hours")
              .format("DD-MM-YYYY HH:mm:ss")
          })
        );
        this.vectorShipFraudSearch = new VectorSource({
          features: shipFraudSearch
        });

        var shipFraudSearch_style = {};

        this.markerShipFraudSearch = new VectorLayer({
          source: this.vectorShipFraudSearch,
          style: function(feature) {
            var style = shipFraudSearch_style;

            style = new Style({
              image: new CircleStyle({
                radius: 5,
                fill: new Fill({ color: "#0449b8" }),
                stroke: new Stroke({
                  color: "red",
                  width: 2
                })
              }),
              text: new Text({
                text: feature.get("shipname"),
                font: "12px Calibri,sans-serif",
                fill: new Fill({
                  color: "#000"
                }),
                offsetY: -20,
                stroke: new Stroke({
                  color: "#D4BE6A",
                  width: 3
                })
              })
            });

            return style;
          }
        });

        this.olmap.addLayer(this.markerShipFraudSearch);
        this.markerShipFraudSearch.setZIndex(3);

        this.iconFraudRadius = new Style({
          fill: new Fill({
            color: "rgba(255, 100, 50, 0.3)"
          }),
          stroke: new Stroke({
            width: 2,
            color: "rgba(255, 100, 50, 0.8)"
          }),
          image: new CircleStyle({
            fill: new Fill({
              color: "rgba(55, 200, 150, 0.5)"
            }),
            stroke: new Stroke({
              width: 1,
              color: "rgba(55, 200, 150, 0.8)"
            })
          })
        });

        let fraudRadius = [];
        fraudRadius.push(
          new Feature({
            geometry: new Circle(
              transform(
                [
                  parseFloat(nextProps.shipFraud[1]),
                  parseFloat(nextProps.shipFraud[0])
                ],
                "EPSG:4326",
                "EPSG:3857"
              ),
              1600
            ),
            name: "asd",
            jenis: "fraudradius"
          })
        );
        this.vectorSourceFraudRadius = new VectorSource({
          features: fraudRadius
        });
        this.markerFraudRadius = new VectorLayer({
          source: this.vectorSourceFraudRadius,
          style: this.iconFraudRadius
        });
        this.olmap.addLayer(this.markerFraudRadius);
        this.setState({ searchFraud: this.markerFraudRadius });
        this.olmap.removeLayer(this.state.searchFraud);
      }
    }

    //end ship fraud

    //vessel point track
    if (this.state.vesselTrack !== null) {
      this.olmap.removeLayer(this.state.vesselTrack);
    }
    if (nextProps.vesselPointTrack[1] !== 0) {
      let vesseltrack = [];
      vesseltrack.push(
        new Feature({
          geometry: new Point(
            fromLonLat([
              parseFloat(nextProps.vesselPointTrack[1]),
              parseFloat(nextProps.vesselPointTrack[0])
            ])
          ),
          name: "asd",
          lat: parseFloat(nextProps.vesselPointTrack[0]).toFixed(4),
          lon: parseFloat(nextProps.vesselPointTrack[1]).toFixed(4),
          date_created: moment(nextProps.vesselPointTrack[2]).format(
            "DD/MM/YYYY H:mm:ss"
          ),
          speed: (parseInt(nextProps.vesselPointTrack[3]) * 0.1).toFixed(2)
        })
      );
      this.vectorSourceVesselPointTrack = new VectorSource({
        features: vesseltrack
      });
      var trackStyle = {};
      this.markerVectorLayer_vesseltrack = new VectorLayer({
        source: this.vectorSourceVesselPointTrack,
        style: function(feature) {
          var style = trackStyle;
          style = new Style({
            // image: new Icon({
            //   opacity: 1,
            //   src: icon_target,
            //   scale: 0.1
            // }),
            text: new Text({
              text:
                "Latitude: " +
                feature.get("lat") +
                " | " +
                "Longitude: " +
                feature.get("lon") +
                " | " +
                "Date: " +
                feature.get("date_created") +
                " | " +
                "Speed: " +
                feature.get("speed") +
                " knot",
              font: "12px Calibri,sans-serif",
              fill: new Fill({
                color: "rgba(255, 255, 255, 1)"
              }),
              backgroundFill: new Fill({
                color: "rgba(0, 0, 0, 0.7)"
              }),
              padding: [3, 3, 3, 3],
              textBaseline: "bottom",
              offsetY: -10
            }),
            image: new RegularShape({
              radius: 8,
              points: 3,
              angle: Math.PI,
              displacement: [0, 10],
              stroke: new Stroke({
                color: "rgba(0, 0, 0, 0.7)",
                width: 2
              })
            })
          });
          return style;
        }
      });
      this.olmap.addLayer(this.markerVectorLayer_vesseltrack);
      this.markerVectorLayer_vesseltrack.setZIndex(2);
      this.setState({ vesselTrack: this.markerVectorLayer_vesseltrack });
      this.olmap.removeLayer(this.state.vesselTrack);
    }
    //end vessel point track

    //ship track
    var pointsx = nextProps.pointShipTrack;

    if (pointsx.length > 0) {
      const dat = pointsx.split(",");
      const chunks = _.chunk(dat, 2);
      for (var i = 0; i < chunks.length; i++) {
        chunks[i] = transform(
          [parseFloat(chunks[i][0]), parseFloat(chunks[i][1])],
          "EPSG:4326",
          "EPSG:3857"
        );
      }

      this.layerLines = new VectorLayer({
        source: new VectorSource({
          features: [
            new Feature({
              geometry: new LineString(chunks),
              name: "Line"
            })
          ]
        }),
        style: new Style({
          fill: new Fill({
            color: "red"
          }),
          stroke: new Stroke({
            color: "rgb(0, 153, 255)",
            lineDash: [3, 3],
            width: 2
          })
        })
      });

      // if (this.state.layerLines !== "") {
      //   this.state.layerLines.getSource().clear();
      // }
      this.olmap.addLayer(this.layerLines);
      //this.olmap.removeLayer(this.layerLines);
      let arraytengah = Math.max(Math.ceil(chunks.length / 2) - 1, 0);

      let aa = transform(
        [
          parseFloat(chunks[arraytengah][0]),
          parseFloat(chunks[arraytengah][1])
        ],
        "EPSG:3857",
        "EPSG:4326"
      );

      let ab = aa[0] + aa[1];

      this.setState({
        layerLinesnya: this.layerLines,
        poi_centerline: ab
      });

      // getBounds center zoom
      var extent = this.layerLines.getSource().getExtent();
      this.olmap
        .getView()
        .fit(extent, { size: this.olmap.getSize(), maxZoom: 16 });
      // end getbound

      // tanda
      // if (this.state.poi_centerline !== ab) {
      //   this.olmap.setView(
      //     new OlView({
      //       center: fromLonLat([parseFloat(aa[0]), parseFloat(aa[1])]),
      //       zoom: 9
      //     })
      //   );
      // }
    }
    //ship track

    //tracking
    var tracking = nextProps.shipTrack;
    // this.setState({ track: tracking });
    // console.log(tracking, "ttt");

    if (tracking.length > 0) {
      const dat = tracking.split(",");
      const chunks = _.chunk(dat, 4);
      for (var i = 0; i < chunks.length; i++) {
        chunks[i] = transform(
          [parseFloat(chunks[i][0]), parseFloat(chunks[i][1])],
          "EPSG:4326",
          "EPSG:3857"
        );
      }
      const chunks1 = _.chunk(dat, 4);

      if (chunks1.length > 1) {
        this.route = new LineString(chunks);

        let routeCoords = this.route.getCoordinates();
        let routeLength = routeCoords.length;

        this.routeFeature = new Feature({
          type: "route",
          geometry: this.route
        });
        this.startMarker = new Feature({
          geometry: new Point(chunks[routeLength - 1])
        });
        this.endMarker = new Feature({
          geometry: new Point(chunks[0])
        });
        this.geoMarker = new Feature({
          type: "geoMarker",
          geometry: new Point(chunks[routeLength - 1])
        });

        const styles = {
          route: new Style({
            fill: new Fill({
              color: "red"
            }),
            stroke: new Stroke({
              color: "rgb(7, 108, 176)",
              lineDash: [3, 3],
              width: 2
            })
          }),
          geoMarker: new Style({
            image: new CircleStyle({
              radius: 7,
              fill: new Fill({ color: "black" }),
              stroke: new Stroke({
                color: "white",
                width: 2
              })
            })
          })
        };

        this.animationLayer = new VectorLayer({
          source: new VectorSource({
            features: [
              this.routeFeature,
              this.geoMarker,
              this.startMarker,
              this.endMarker
            ]
          }),
          style: function(feature) {
            return styles[feature.get("type")];
          }
        });

        this.layerLines = new VectorLayer({
          source: new VectorSource({
            features: [
              new Feature({
                geometry: new LineString(chunks),
                name: "Line"
              })
            ]
          }),
          style: new Style({
            fill: new Fill({
              color: "red"
            }),
            stroke: new Stroke({
              color: "rgb(7, 108, 176)",
              lineDash: [3, 3],
              width: 2
            })
          })
        });

        let dataPoint = [];

        chunks1.map(e => {
          dataPoint.push(
            new Feature({
              geometry: new Point(
                fromLonLat([parseFloat(e[0]), parseFloat(e[1])])
              ),
              name: "Track",
              datetime: e[2],
              lon: e[0],
              lat: e[1],
              speedTrack: e[3]
            })
          );
        });

        this.vectorSourcePoint = new VectorSource({
          features: dataPoint
        });

        var pointStyle = {};
        this.vectorLayer_point = new VectorLayer({
          source: this.vectorSourcePoint,
          style: function(feature) {
            var style = pointStyle;
            var speed = feature.get("speedTrack");
            speed = speed * 0.1;
            if (speed.toFixed(2) <= 5) {
              style = new Style({
                image: new Icon({
                  opacity: 1,
                  src: require(`../../assets/poi/7b.png`),
                  scale: 0.1
                })
              });
            } else {
              style = new Style({
                image: new Icon({
                  opacity: 1,
                  src: require(`../../assets/poi/2b.png`),
                  scale: 0.1
                })
              });
            }

            return style;
          }
        });

        this.olmap.addLayer(this.animationLayer);
        //this.olmap.addLayer(this.layerLines);
        this.olmap.addLayer(this.vectorLayer_point);

        // getBounds center zoom
        var extent = this.vectorLayer_point.getSource().getExtent();
        this.olmap
          .getView()
          .fit(extent, { size: this.olmap.getSize(), maxZoom: 16 });
        // end getbound

        let arraytengah = Math.max(Math.ceil(chunks.length / 2) - 1, 0);

        let aa = transform(
          [
            parseFloat(chunks[arraytengah][0]),
            parseFloat(chunks[arraytengah][1])
          ],
          "EPSG:3857",
          "EPSG:4326"
        );

        let ab = aa[0] + aa[1];

        this.setState({
          layerLinesnya: this.animationLayer,
          layerPointsnya: this.vectorLayer_point,
          track_centerline: ab
        });

        var moveFeature = function(event) {
          var vectorContext = event.vectorContext;
          var frameState = event.frameState;
          var elapsedTime = frameState.time - now;
          var index = Math.round((speed * elapsedTime) / 1000);
          if (index >= routeLength) {
            var coord = chunks[0];
            this.geoMarker.getGeometry().setCoordinates(coord);
            this.olmap.un("postcompose", moveFeature);
          }

          // var currentPoint = new Point(chunks[0]);
          // var feature = new Feature(currentPoint);
          // vectorContext.drawFeature(feature, styles.geoMarker);

          this.olmap.render();
        };

        let now = new Date().getTime();
        let speed = 30;

        this.geoMarker.setStyle(null);
        this.olmap.on("postcompose", evt => {
          var vectorContext = evt.vectorContext;
          var frameState = evt.frameState;
          var elapsedTime = frameState.time - now;
          var index = Math.round((speed * elapsedTime) / 1000);
          if (index >= routeLength) {
            var coord = chunks[0];
            this.geoMarker.getGeometry().setCoordinates(coord);
            this.olmap.un("postcompose", moveFeature);
          }

          // var currentPoint = new Point(chunks[0]);
          // var feature = new Feature(currentPoint);
          // vectorContext.drawFeature(feature, styles.geoMarker);

          this.olmap.render();
        });
        this.olmap.render();

      }

      // if (this.state.track_centerline !== ab) {
      //   this.olmap.setView(
      //     new OlView({
      //       center: fromLonLat([parseFloat(aa[0]), parseFloat(aa[1])]),
      //       zoom: 8
      //     })
      //   );
      // }
    }
    //tracking

    //near ship tracking
    var nearTracking = nextProps.shipTrack2;

    if (nearTracking.length > 0) {
      const dat = nearTracking.split(",");
      const chunks = _.chunk(dat, 4);
      for (var i = 0; i < chunks.length; i++) {
        chunks[i] = transform(
          [parseFloat(chunks[i][0]), parseFloat(chunks[i][1])],
          "EPSG:4326",
          "EPSG:3857"
        );
      }
      const chunks1 = _.chunk(dat, 4);

      this.route1 = new LineString(chunks);

      let routeCoords1 = this.route1.getCoordinates();
      let routeLength1 = routeCoords1.length;

      this.routeFeature1 = new Feature({
        type: "route",
        geometry: this.route1
      });
      this.startMarker1 = new Feature({
        geometry: new Point(chunks[routeLength1 - 1])
      });
      this.endMarker1 = new Feature({
        geometry: new Point(chunks[0])
      });
      this.geoMarker1 = new Feature({
        type: "geoMarker",
        geometry: new Point(chunks[routeLength1 - 1])
      });

      const styles1 = {
        route: new Style({
          fill: new Fill({
            color: "red"
          }),
          stroke: new Stroke({
            color: "rgb(228, 8, 252)",
            lineDash: [3, 3],
            width: 2
          })
        }),
        geoMarker: new Style({
          image: new CircleStyle({
            radius: 7,
            fill: new Fill({ color: "red" }),
            stroke: new Stroke({
              color: "white",
              width: 2
            })
          })
        })
      };

      this.animationLayer1 = new VectorLayer({
        source: new VectorSource({
          features: [
            this.routeFeature1,
            this.geoMarker1,
            this.startMarker1,
            this.endMarker1
          ]
        }),
        style: function(feature) {
          return styles1[feature.get("type")];
        }
      });

      this.layerLines1 = new VectorLayer({
        source: new VectorSource({
          features: [
            new Feature({
              geometry: new LineString(chunks),
              name: "Line"
            })
          ]
        }),
        style: new Style({
          fill: new Fill({
            color: "red"
          }),
          stroke: new Stroke({
            color: "rgb(228, 8, 252)",
            lineDash: [3, 3],
            width: 2
          })
        })
      });

      let dataIdle = [];

      chunks1.map(e => {
        dataIdle.push(
          new Feature({
            geometry: new Point(
              fromLonLat([parseFloat(e[0]), parseFloat(e[1])])
            ),
            name: "Track",
            datetime: e[2],
            lon: e[0],
            lat: e[1],
            speedTrack: e[3]
          })
        );
      });

      this.vectorSourcePoint1 = new VectorSource({
        features: dataIdle
      });

      var nearStyle = {};
      this.vectorLayer_point1 = new VectorLayer({
        source: this.vectorSourcePoint1,
        style: function(feature) {
          var style = nearStyle;
          var speed = feature.get("speedTrack");
          speed = speed * 0.1;
          if (speed.toFixed(2) <= 5) {
            style = new Style({
              image: new Icon({
                opacity: 1,
                src: require(`../../assets/poi/7b.png`),
                scale: 0.1
              })
            });
          } else {
            style = new Style({
              image: new Icon({
                opacity: 1,
                src: require(`../../assets/poi/2b.png`),
                scale: 0.1
              })
            });
          }

          return style;
        }
      });

      this.olmap.addLayer(this.animationLayer1);
      //this.olmap.addLayer(this.layerLines);
      this.olmap.addLayer(this.vectorLayer_point1);

      // getBounds center zoom
      var extent1 = this.vectorLayer_point1.getSource().getExtent();
      this.olmap
        .getView()
        .fit(extent1, { size: this.olmap.getSize(), maxZoom: 16 });
      // end getbound

      this.setState({
        layerLinesnya1: this.animationLayer1,
        layerPointsnya1: this.vectorLayer_point1
      });

      var moveFeature1 = function(event) {
        var vectorContext = event.vectorContext;
        var frameState = event.frameState;
        var elapsedTime = frameState.time - now;
        var index = Math.round((speed * elapsedTime) / 1000);
        if (index >= routeLength1) {
          var coord = chunks[0];
          this.geoMarker1.getGeometry().setCoordinates(coord);
          this.olmap.un("postcompose", moveFeature1);
        }

        // var currentPoint = new Point(chunks[0]);
        // var feature = new Feature(currentPoint);
        // vectorContext.drawFeature(feature, styles.geoMarker);

        this.olmap.render();
      };

      let now = new Date().getTime();
      let speed = 30;

      this.geoMarker1.setStyle(null);
      this.olmap.on("postcompose", evt => {
        var vectorContext = evt.vectorContext;
        var frameState = evt.frameState;
        var elapsedTime = frameState.time - now;
        var index = Math.round((speed * elapsedTime) / 1000);
        if (index >= routeLength1) {
          var coord = chunks[0];
          this.geoMarker1.getGeometry().setCoordinates(coord);
          this.olmap.un("postcompose", moveFeature1);
        }

        // var currentPoint = new Point(chunks[0]);
        // var feature = new Feature(currentPoint);
        // vectorContext.drawFeature(feature, styles.geoMarker);

        this.olmap.render();
      });
      this.olmap.render();
    }
    //end near ship tracking

    //draw from drawsave

    let zoneTarget = nextProps.zoneTarget[0];

    if (typeof zoneTarget == "undefined") {
      zoneTarget = [];
    }
    if (nextProps.activeDrawing === false) {
      let zone_target = [];
      // this.state.zoneTarget.map(e => {
      //   e.getSource().clear();
      // });
      this.state.zoneTarget.map(e => {
        // e.getSource().clear();
        this.olmap.removeLayer(e);
        this.olmap.removeLayer(this.state.layerLinesnya);
        this.olmap.removeLayer(this.state.layerPointsnya);
        this.olmap.removeLayer(this.state.layerLinesnya1);
        this.olmap.removeLayer(this.state.layerPointsnya1);
        this.olmap.removeLayer(this.state.vesselTrack);
        this.olmap.removeLayer(this.state.fraudApp);
        this.props.pushActiveDrawing(false);
      });
      // this.olmap.removeLayer(this.state.zoneTarget);
      this.olmap.removeLayer(this.state.layerLinesnya);
      this.olmap.removeLayer(this.state.layerPointsnya);
      this.olmap.removeLayer(this.state.layerLinesnya1);
      this.olmap.removeLayer(this.state.layerPointsnya1);
      this.olmap.removeLayer(this.state.vesselTrack);
      this.olmap.removeLayer(this.state.fraudApp);
      // this.props.pushZonaTarget([]);
      // this.props.pushActiveDrawing(false);

      zoneTarget.map(i => {
        const zone = JSON.parse(i.val);
        if (i.checked === true) {
          this.source = new VectorSource({
            features: new GeoJSON().readFeatures(zone)
          });
          this.layer = new VectorLayer({
            source: this.source
          });
          const feature = this.source.getFeatures()[0];
          const polygon = feature.getGeometry();
          //const pol = feature.geometry.getBounds();
          //const pol = polygon.getVertices();
          const a = polygon.extent_;
          var X = a[0] + (a[2] - a[0]) / 2;
          var Y = a[1] + (a[3] - a[1]) / 2;
          const ac = [X, Y];
          const aa = transform(ac, "EPSG:3857", "EPSG:4326");

          this.olmap.setView(
            new OlView({
              center: fromLonLat(aa),
              zoom: 8
            })
          );
          this.olmap.addLayer(this.layer);
          zone_target.push(this.layer);
          this.setState({ zoneTarget: zone_target });
        } else {
          this.state.zoneTarget.map(e => {
            e.getSource().clear();
          });
        }

        // if (this.state.zoneTarget !== []) {
        //   this.state.zoneTarget.getSource().clear();
        // }
      });
    }
    //end draw from drawsave

    //port search
    //centertarget tanda
    // if (nextProps.poiTarget[1] != 0) {
    //   console.log(nextProps.poiTarget[1]);
    //   this.olmap.setView(
    //     new OlView({
    //       center: fromLonLat([
    //         parseFloat(nextProps.poiTarget[1]),
    //         parseFloat(nextProps.poiTarget[0])
    //       ]),
    //       zoom: 12
    //     })
    //   );
    // }

    if (this.state.searchPORT !== null) {
      this.olmap.removeLayer(this.state.searchPORT);
    }
    if (nextProps.portTarget[1] !== 0) {
      this.iconStyle_icon_search = new Style({
        image: new Icon({
          opacity: 1,
          src: icon_target,
          scale: 0.1
        })
      });
      let poisearch = [];
      poisearch.push(
        new Feature({
          geometry: new Point(
            fromLonLat([
              parseFloat(nextProps.portTarget[1]),
              parseFloat(nextProps.portTarget[0])
            ])
          ),
          name: "asd",
          jenis: "pointvessel"
        })
      );
      this.vectorSourcePoiSearch = new VectorSource({
        features: poisearch
      });
      this.markerVectorLayer_poisearch = new VectorLayer({
        source: this.vectorSourcePoiSearch,
        style: this.iconStyle_icon_search
      });
      this.olmap.addLayer(this.markerVectorLayer_poisearch);
      this.setState({ searchPOI: this.markerVectorLayer_poisearch });

      this.iconStyle_icon_target = new Style({
        image: new Icon({
          opacity: 1,
          src: require(`../../assets/poi/port.png`),
          scale: 0.35
        })
      });
      let porttender = [];
      porttender.push(
        new Feature({
          geometry: new Point(
            fromLonLat([
              parseFloat(nextProps.portTarget[1]),
              parseFloat(nextProps.portTarget[0])
            ])
          ),
          // ini dia
          gid: nextProps.portTarget[2],
          district: nextProps.portTarget[5],
          address: nextProps.portTarget[4],
          description: nextProps.portTarget[12],
          name: nextProps.portTarget[3],
          subdistrict: nextProps.portTarget[3],
          dimensi: nextProps.portTarget[3],
          subdimensi: nextProps.portTarget[3],
          geomtype: "port"
        })
      );
      this.vectorSourcePorttender = new VectorSource({
        features: porttender
      });
      this.markerVectorLayer_porttender = new VectorLayer({
        source: this.vectorSourcePorttender,
        style: this.iconStyle_icon_target
      });
      this.olmap.addLayer(this.markerVectorLayer_porttender);
      this.setState({ searchPORT: this.markerVectorLayer_porttender });
      // tanda
      // if (nextProps.poiTarget[1] !== this.props.poiTarget[1]) {
      //   this.olmap.setView(
      //     new OlView({
      //       center: fromLonLat([
      //         parseFloat(nextProps.portTarget[1]),
      //         parseFloat(nextProps.portTarget[0])
      //       ]),
      //       zoom: 15
      //     })
      //   );
      // }
      this.olmap.removeLayer(this.state.searchPOI);
    }
    //port search end

    // basemap

    this.olmap.removeLayer(this.state.layerMQ);
    if (nextProps.layerAdd != null) {
      let res = nextProps.layerAdd.split("|");

      const urlss =
        //'https://gis.bmkg.go.id/arcgis/rest/services/' +
        res[0];

      const layerMQ = new ImageLayer({
        source: new ImageArcGISRest({
          ratio: 1,
          params: { LAYER: res[1] },
          url: urlss
        })
      });

      this.setState({ layerMQ: layerMQ });

      this.olmap.addLayer(layerMQ);
    }
    // end basemap

    //load vessel

    let vesselSelected = nextProps.vesselSelected[0];

    if (typeof vesselSelected !== "undefined") {
      let marker_vessel = [];
      this.state.marker_vessel.map(e => {
        this.olmap.removeLayer(e);
      });

      vesselSelected.map(i => {
        let dataVessel = [];
        let a = parseInt(i.val);

        this.state.vesselData.map(e => {
          if (i.checked == true && e.shiptype == a) {
            dataVessel.push(
              new Feature({
                geometry: new Point(
                  fromLonLat([parseFloat(e.lon), parseFloat(e.lat)])
                ),
                name: e.shipname,
                hdg: e.heading,
                typenya: e.shiptype,
                geomtype: "vessel",
                course: e.course,
                elapsed: e.elapsed,
                heading: e.heading,
                lat: e.lat,
                lon: e.lon,
                shipname: e.shipname,
                shiptype: e.shiptype,
                ship_id: e.ship_id,
                speed: e.speed * 0.1,
                destination: e.destination,
                width: e.width,
                length: e.length,
                dwt: e.dwt,
                call_sign: e.call_sign,
                rot: e.rot,
                flag: e.flag,
                date_created: e.date_created,
                status_name: e.status_name,
                type_img: e.type_img,
                type_name: e.type_name,
                geofenceport_name: e.geofenceport_name,
                geofenceport_status: e.geofenceport_status,
                id: e.id
              })
            );
          }
        });

        this.vectorSourcePoiVessel = new VectorSource({
          features: dataVessel
        });

        var styleCache_pilotvessel = {};

        this.markerVectorLayer_poiVessel = new VectorLayer({
          source: this.vectorSourcePoiVessel,
          style: function(feature) {
            var style = styleCache_pilotvessel;
            var urlicovessel;
            if (
              feature.get("hdg") == null ||
              feature.get("hdg") == "None" ||
              feature.get("hdg") == "null"
            ) {
              style = new Style({
                image: new Icon({
                  opacity: 1,
                  src: require(`../../assets/poi/${feature.get(
                    "typenya"
                  )}.png`),
                  scale: 0.1,
                  rotation: parseFloat(feature.get("course")) * 0.01745329251,
                  rotateWithView: "true"
                })
              });
            } else {
              style = new Style({
                image: new Icon({
                  opacity: 1,
                  src: require(`../../assets/poi/${feature.get(
                    "typenya"
                  )}.png`),
                  scale: 0.1,
                  rotation: parseFloat(feature.get("hdg")) * 0.01745329251,
                  rotateWithView: "true"
                })
              });
            }

            return style;
          }
        });

        this.olmap.addLayer(this.markerVectorLayer_poiVessel);
        this.markerVectorLayer_poiVessel.setZIndex(3);
        marker_vessel.push(this.markerVectorLayer_poiVessel);
      });

      this.setState({
        marker_vessel: marker_vessel
      });
    } else {
      vesselSelected = [];
    }

    //end vessel

    //vessel pertamina

    if (nextProps.sourceAis !== this.props.sourceAis) {
      this.props.pushLoader(true);
      this.props.pushPoiTarget([0, 0]);

      fetchVesselPtmSourcexy(nextProps.sourceAis)
        .then(response => {
          this.setState({ vesselDataPtm: response.data.results });
          this.props.pushVesselPtmSelected(false);
          this.props.pushVesselPtmSelected(true);
          this.props.pushLoader(false);
        })
        .catch(error => {
          console.log(error);
          localStorage.clear();
          if (this.state.oauth == "") {
            return <Redirect to={"/pages/login"} />;
          } else {
            // window.open("https://identity.idaman.pertamina.com/logout");
            return <Redirect to={"/pages/login"} />;
          }
        });
    }

    let marker_vessel_ptm = [];
    if (nextProps.vesselPtmChecked == true) {
      this.state.marker_vessel_ptm.map(e => {
        this.olmap.removeLayer(e);
      });

      let dataVesselPtm = [];
      this.state.vesselDataPtm.map(e => {
        if (
          e.lat == 0 ||
          e.lat == "0" ||
          parseFloat(e.lat) > 90 ||
          parseFloat(e.lat) < -90
        ) {
          return false;
        }

        dataVesselPtm.push(
          new Feature({
            geometry: new Point(
              fromLonLat([parseFloat(e.lon), parseFloat(e.lat)])
            ),
            name: e.shipname,
            hdg: e.heading,
            typenya: e.shiptype,
            geomtype: "vessel",
            course: e.course,
            elapsed: e.elapsed,
            heading: e.heading,
            lat: e.lat,
            lon: e.lon,
            shipname: e.shipname,
            shiptype: e.shiptype,
            ship_id: e.ship_id,
            speed: e.speed * 0.1,
            destination: e.destination,
            width: e.width,
            length: e.length,
            dwt: e.dwt,
            call_sign: e.call_sign,
            rot: e.rot,
            flag: e.flag,
            date_created: e.date_created,
            status_name: e.status_name,
            type_img: e.type_img,
            type_name: e.type_name,
            geofenceport_status: e.geofenceport_status,
            geofenceport_name: e.geofenceport_name,
            vessel_status: e.vessel_status,
            vessel_container: e.vessel_container,
            remark: e.remark,
            ipman_container_value: e.ipman_container_value,
            ipman_activity: e.ipman_activity,
            ipman_plant: e.ipman_plant,
            ipman_eta: e.ipman_eta,
            ipman_ata: e.ipman_ata,
            ipman_remark: e.ipman_remark,
            ipman_container: e.ipman_container,
            eta: e.eta,
            source: e.source
          })
        );
      });

      this.vectorSourcePoiPtm = new VectorSource({
        features: dataVesselPtm
      });

      var clusterSource_ptm = new Cluster({
        distance: parseInt(20, 10),
        source: this.vectorSourcePoiPtm
      });

      var styleCache_pilotvesselPtm = {};

      let sourceClusterornot;
      //jika level guest atau administrator
      let userlevel = localStorage.getItem("userlevel");

      if (userlevel == "2" || userlevel == "3") {
        this.markerVectorLayer_poiPtm = new VectorLayer({
          source: clusterSource_ptm,
          style: function(feature) {
            //console.log(feature.get("speed"));

            var urlicovessel;
            let colornya;
            let iconvesselptm;

            var size = feature.get("features").length;

            var style = styleCache_pilotvesselPtm[size];
            if (size > 1) {
              style = new Style({
                image: new CircleStyle({
                  radius: 10,
                  stroke: new Stroke({
                    color: "#fff"
                  }),
                  fill: new Fill({
                    color: "#1A1A59"
                  })
                }),
                text: new Text({
                  text: size.toString(),
                  fill: new Fill({
                    color: "#fff"
                  })
                })
              });
              styleCache_pilotvesselPtm[size] = style;
            } else {
              var features = feature.get("features");

              if (
                features[0].get("speed") > 3 ||
                features[0].get("geofenceport_status") === 1 ||
                (features[0].get("geofencesungai_status") === 1 &&
                  feature[0].get("speed") > 1)
              ) {
                colornya = "#A4A7B6";
              } else {
                colornya = "#D4BE6A";
              }

              if (features[0].get("geofenceport_status") == "1") {
                iconvesselptm = "inport.png";
              } else if (features[0].get("vessel_status") == "off hire") {
                iconvesselptm = "offhire.png";
              } else {
                if (
                  features[0].get("ship_id") == "6530126" ||
                  features[0].get("ship_id") == "6571896" ||
                  features[0].get("ship_id") == "726087" ||
                  features[0].get("ship_id") == "726767" ||
                  features[0].get("ship_id") == "198333" ||
                  features[0].get("ship_id") == "714235" ||
                  features[0].get("ship_id") == "726785"
                ) {
                  iconvesselptm = "7.png";
                } else {
                  iconvesselptm = "99.png";
                }
              }

              let rotation;

              if (
                features[0].get("hdg") == null ||
                features[0].get("hdg") == "None" ||
                features[0].get("hdg") == "" ||
                features[0].get("hdg") == "null"
              ) {
                rotation =
                  parseFloat(features[0].get("course")) * 0.01745329251;
              } else {
                rotation = parseFloat(features[0].get("hdg")) * 0.01745329251;
              }

              style = new Style({
                image: new Icon({
                  opacity: 1,
                  src: require(`../../assets/poi/${iconvesselptm}`),
                  scale: 0.1,
                  rotation: rotation,
                  rotateWithView: "true"
                }),
                stroke: new Stroke({
                  color: "blue",
                  width: 1
                }),
                fill: new Fill({
                  color: "rgba(0, 0, 255, 0.1)"
                }),
                text: new Text({
                  text:
                    features[0].get("name") +
                    " | " +
                    features[0].get("speed").toFixed(2) +
                    " knot",
                  font: "12px Calibri,sans-serif",
                  fill: new Fill({
                    color: "#000"
                  }),
                  offsetY: -20,
                  stroke: new Stroke({
                    color: colornya,
                    width: 3
                  })
                })
              });
              styleCache_pilotvesselPtm[size] = style;
            }

            return style;
          }
        });
      } else {
        this.markerVectorLayer_poiPtm = new VectorLayer({
          source: this.vectorSourcePoiPtm,
          style: function(feature) {
            var style = styleCache_pilotvesselPtm;
            var urlicovessel;
            let colornya;
            let iconvesselptm;

            if (feature.get("speed") > 3) {
              colornya = "#A4A7B6";
            } else {
              colornya = "#D4BE6A";
            }

            if (feature.get("geofenceport_status") == "1") {
              iconvesselptm = "inport.png";
            } else if (feature.get("vessel_status") == "off hire") {
              iconvesselptm = "offhire.png";
            } else {
              if (
                feature.get("ship_id") == "6530126" ||
                feature.get("ship_id") == "6571896" ||
                feature.get("ship_id") == "726087" ||
                feature.get("ship_id") == "726767" ||
                feature.get("ship_id") == "198333" ||
                feature.get("ship_id") == "714235" ||
                feature.get("ship_id") == "726785"
              ) {
                iconvesselptm = "7.png";
              } else {
                iconvesselptm = "99.png";
              }
            }

            let rotation;

            if (
              feature.get("hdg") == null ||
              feature.get("hdg") == "None" ||
              feature.get("hdg") == "" ||
              feature.get("hdg") == "null"
            ) {
              rotation = parseFloat(feature.get("course")) * 0.01745329251;
            } else {
              rotation = parseFloat(feature.get("hdg")) * 0.01745329251;
            }

            style = new Style({
              image: new Icon({
                opacity: 1,
                src: require(`../../assets/poi/${iconvesselptm}`),
                scale: 0.1,
                rotation: rotation,
                rotateWithView: "true"
              }),
              stroke: new Stroke({
                color: "blue",
                width: 1
              }),
              fill: new Fill({
                color: "rgba(0, 0, 255, 0.1)"
              }),
              text: new Text({
                text:
                  feature.get("name") +
                  " | " +
                  feature.get("speed").toFixed(2) +
                  " knot",
                font: "12px Calibri,sans-serif",
                fill: new Fill({
                  color: "#000"
                }),
                offsetY: -20,
                stroke: new Stroke({
                  color: colornya,
                  width: 3
                })
              })
            });

            return style;
          }
        });
      }

      this.olmap.addLayer(this.markerVectorLayer_poiPtm);
      this.markerVectorLayer_poiPtm.setZIndex(3);
      marker_vessel_ptm.push(this.markerVectorLayer_poiPtm);

      this.setState({
        marker_vessel_ptm: marker_vessel_ptm
      });
    } else {
      this.state.marker_vessel_ptm.map(e => {
        this.olmap.removeLayer(e);
      });
    }

    //end vessel pertamina

    // load weatherbit

    if (nextProps.weatherChecked == true) {
      let marker_weather = [];
      let weatherIndo = [];

      this.state.marker_weather.map(e => {
        this.olmap.removeLayer(e);
      });

      this.source = new TileWMS({
        url: "https://wms.redbit.co.id/geoserver/pertamina/wms?",
        params: {
          LAYERS: "pertamina:weather_weather",
          TILED: true
        },
        serverType: "geoserver"
      });
      this.layerWms = new TileLayer({
        source: this.source
      });
      this.olmap.addLayer(this.layerWms);

      // fetchWeatherIndo()
      //   .then(response => {
      //     this.iconStyle_icon = new Style({
      //       image: new Icon({
      //         opacity: 1,
      //         src: require(`../../assets/wind/wind1-2.png`),
      //         scale: 1,
      //         rotation: parseFloat(0),
      //         rotateWithView: "true"
      //       })
      //     });

      //     let dataWeather = [];
      //     response.data.results.map(e => {
      //       let icon = "wind1-2.png";

      //       dataWeather.push(
      //         new Feature({
      //           geometry: new Point(
      //             fromLonLat([parseFloat(e.lon), parseFloat(e.lat)])
      //           ),
      //           name: e.pagename,
      //           wind_dir: e.wind_dir,
      //           wind_speed: e.wind_speed,
      //           description: e.description,
      //           temp: e.temp,
      //           geomtype: "weather"
      //         })
      //       );
      //     });

      //     this.vectorSourceWeather = new VectorSource({
      //       features: dataWeather
      //     });
      //     var weather_style = {};
      //     this.markerVectorLayer_poiWeather = new VectorLayer({
      //       source: this.vectorSourceWeather,
      //       style: function(feature) {
      //         var style = weather_style;

      //         let icon = "wind1-2.png";
      //         let x = parseInt(feature.get("wind_speed"));

      //         switch (true) {
      //           case x >= 0 && x <= 1:
      //             // code block
      //             icon = "wind1-2.png";
      //             break;
      //           case x >= 2 && x <= 3:
      //             // code block
      //             icon = "wind3-7.png";
      //             break;
      //           case x >= 4 && x <= 5:
      //             // code block
      //             icon = "wind8-12.png";
      //             break;
      //           case x >= 6 && x <= 7:
      //             // code block
      //             icon = "wind13-17.png";
      //             break;
      //           case x >= 8 && x <= 9:
      //             // code block
      //             icon = "wind18-22.png";
      //             break;
      //           case x >= 10 && x <= 11:
      //             // code block
      //             icon = "wind23-27.png";
      //             break;
      //           case x >= 12 && x <= 15:
      //             // code block
      //             icon = "wind58-92.png";
      //             break;
      //           case x >= 16:
      //             // code block
      //             icon = "wind98-102.png";
      //             break;
      //           default:
      //             icon = "wind1-2.png";
      //           // code block
      //         }

      //         style = new Style({
      //           image: new Icon({
      //             opacity: 1,
      //             src: require(`../../assets/wind/${icon}`),
      //             scale: 1,
      //             rotation: parseFloat(feature.get("wind_dir")) * 0.01545329251,
      //             rotateWithView: "true"
      //           })
      //         });
      //         return style;
      //       }
      //     });

      //     this.olmap.addLayer(this.markerVectorLayer_poiWeather);

      //     this.markerVectorLayer_poiWeather.setZIndex(3);
      //   })
      //   .catch(error => {
      //     console.log(error);
      //   });

      // weather loop
      marker_weather.push(this.layerWms);
      this.setState({
        marker_weather: marker_weather
      });
    } else {
      this.state.marker_weather.map(e => {
        this.olmap.removeLayer(e);
      });
    }

    //end load weather

    //load bathymetry
    if (nextProps.bathymetryChecked == true) {
      let marker_bathymetry = [];

      this.state.marker_bathymetry.map(e => {
        this.olmap.removeLayer(e);
      });

      this.source = new TileWMS({
        url: "https://wms.redbit.co.id/geoserver/pertamina/wms?",
        params: {
          LAYERS: "pertamina:GEBCO_Ina",
          TILED: true
        },
        serverType: "geoserver"
      });
      this.layerWms = new TileLayer({
        source: this.source
      });
      this.olmap.addLayer(this.layerWms);
      marker_bathymetry.push(this.layerWms);
      this.setState({
        marker_bathymetry: marker_bathymetry
      });
    } else {
      this.state.marker_bathymetry.map(e => {
        this.olmap.removeLayer(e);
      });
    }

    //end bathymetry

    //load poi

    let poiSelected = nextProps.poiSelected[0];

    if (typeof poiSelected !== "undefined") {
      fetchPOI()
        .then(response => {
          this.setState({ poiData: response.data.results });
          // const newdata = { val: "port", checked: false, icon_path: "port.png" };
          //
          // this.props.pushPoiSelected([newdata]);
          if (typeof response.data.results != "undifined") {
            let marker_poi = [];
            this.state.marker_poi.map(e => {
              this.olmap.removeLayer(e);
            });

            // poi category loop
            poiSelected.map(i => {
              let dataPoi = [];

              // poi loop
              response.data.results.map(e => {
                if (i.checked === true && e.category === i.val) {
                  this.iconStyle_icon = new Style({
                    image: new Icon({
                      opacity: 1,
                      src: require(`../../assets/poi/${i.icon_path}`),
                      scale: 0.35
                    })
                  });

                  dataPoi.push(
                    new Feature({
                      geometry: new Point(
                        fromLonLat([
                          parseFloat(e.longitude),
                          parseFloat(e.latitude)
                        ])
                      ),
                      name: e.name,
                      description: e.description,
                      address: e.address,
                      gid: e.gid,
                      subdistrict: e.subdistrict,
                      dimensi: e.dimensi,
                      subdimensi: e.subdimensi,
                      district: e.district,
                      geomtype: "port"
                    })
                  );
                }
              });

              // end poi loop
              this.vectorSourcePoi = new VectorSource({
                features: dataPoi
              });
              this.markerVectorLayer_poi = new VectorLayer({
                source: this.vectorSourcePoi,
                style: this.iconStyle_icon
              });

              this.olmap.addLayer(this.markerVectorLayer_poi);

              this.markerVectorLayer_poi.setZIndex(3);

              marker_poi.push(this.markerVectorLayer_poi);
            });

            // end poi category loop

            this.setState({
              marker_poi: marker_poi
            });
          }
        })
        .catch(error => {
          console.log(error);
          // this.props.history.push("/pages/login#logout");
        });
    } else {
      poiSelected = [];
    }

    //end poi

    // earth earthQuake
    let marker_poiGempa = [];
    if (Object.keys(nextProps.earthQuake).length == 0) {
      this.state.marker_poiGempa.map(e => {
        this.olmap.removeLayer(e);
      });
    } else {
      let datagempa = nextProps.earthQuake;
      let datagempa2 = datagempa.gempa;

      //console.log(datagempa.gempa);
      let coor = datagempa2.coordinates;
      let coor2 = coor.split(",");
      let lat = coor2[0];
      let lon = coor2[1];
      let dataPoiGempa = [];

      this.iconStyle_iconGempa = new Style({
        image: new Icon({
          opacity: 1,
          src: require(`../../assets/poi/earthquake.png`),
          scale: 0.6
        })
      });

      dataPoiGempa.push(
        new Feature({
          geometry: new Point(fromLonLat([parseFloat(lon), parseFloat(lat)])),
          Tanggal: datagempa2.Tanggal,
          Jam: datagempa2.Jam,
          DateTime: datagempa2.DateTime,
          Lintang: datagempa2.Lintang,
          Bujur: datagempa2.Bujur,
          Coordinates: datagempa2.Coordinates,
          Magnitude: datagempa2.Magnitude,
          Kedalaman: datagempa2.Kedalaman,
          Wilayah: datagempa2.Wilayah,
          Potensi: datagempa2.Potensi,
          Dirasakan: datagempa2.Dirasakan,
          Shakemap: datagempa2.Shakemap,
          geomtype: "gempa",
          name: "Earth Quake"
        })
      );

      this.vectorSourcePoiGempa = new VectorSource({
        features: dataPoiGempa
      });
      this.markerVectorLayer_poiGempa = new VectorLayer({
        source: this.vectorSourcePoiGempa,
        style: this.iconStyle_iconGempa
      });

      this.olmap.addLayer(this.markerVectorLayer_poiGempa);

      this.markerVectorLayer_poiGempa.setZIndex(3);

      marker_poiGempa.push(this.markerVectorLayer_poiGempa);

      this.setState({
        marker_poiGempa: marker_poiGempa
      });
    }
    // end earth earthQuake

    this.setState({ drawType: nextProps.drawType });
    if (nextProps.measureStat === true) {
      this.addInteraction(nextProps.drawType);
    } else {
      this.drawTemp.map(e => {
        this.olmap.removeInteraction(e);
      });
      this.vectorTemp.map(e => {
        this.olmap.removeLayer(e);
      });
      this.measureTooltipElement.innerHTML = " ";
    }
  }

  pointerMoveHandler = evt => {
    //console.log(evt.coordinate);
    if (evt.dragging) {
      return;
    }
    //var helpMsg = "Click to start drawing";
    //console.log(evt.coordinate);
    let coordinatecirclelat = transform(
      evt.coordinate,
      "EPSG:3857",
      "EPSG:4326"
    );

    this.props.pushLonlatMouse(coordinatecirclelat);
    this.helpTooltip.setPosition(evt.coordinate);
  };

  componentDidMount() {
    this.props.pushPoiTarget([0, 0]);
    this.props.pushPortTarget([0, 0]);
    this.props.pushVesselPointTrack([0, 0]);
    this.props.pushPointShipTrack([]);
    //this.props.pushShipTrack([]);

    this.olmap.setTarget("map");

    let pointvessel = [];

    this.iconStyle_icon_poi = new Style({
      image: new Icon({
        opacity: 1,
        src: require(`../../assets/poi/port.png`),
        //src: icon,
        scale: 0.06
      })
    });

    this.helpTooltipElement = document.getElementById("tooltipElement");

    this.helpTooltip = new Overlay({
      element: this.helpTooltipElement,
      offset: [15, 0],
      positioning: "center-left"
    });

    this.measureTooltipElement = document.getElementById("measuretooltip");
    this.measureTooltip = new Overlay({
      element: this.measureTooltipElement,
      offset: [0, -15],
      positioning: "bottom-center"
    });

    this.olmap.addOverlay(this.measureTooltip);

    this.container = document.getElementById("popup");
    var closer = document.getElementById("popup-closer");

    //var content = document.getElementById("popupContent");
    var overlay = new Overlay({
      element: this.container,
      autoPan: true,
      autoPanAnimation: {
        duration: 250
      }
    });

    this.olmap.addOverlay(overlay);

    this.olmap.on("pointermove", this.pointerMoveHandler);

    closer.onclick = function() {
      overlay.setPosition(undefined);
      closer.blur();
      return false;
    };

    var selected = null;

    this.olmap.on("pointermove", evt => {
      var map = evt.map;
      var feature = map.forEachFeatureAtPixel(evt.pixel, function(feature) {
        return feature;
      });

      if (feature) {
        if (selected !== null) {
          selected.setStyle(undefined);
          selected = null;
        }

        var typenya = feature.get("typenya");

        if (feature.get("geomtype") == "vessel") {
          let rotation;

          if (
            feature.get("hdg") == null ||
            feature.get("hdg") == "None" ||
            feature.get("hdg") == "" ||
            feature.get("hdg") == "null"
          ) {
            rotation = parseFloat(feature.get("course")) * 0.01745329251;
          } else {
            rotation = parseFloat(feature.get("hdg")) * 0.01745329251;
          }

          var highlightStyle = new Style({
            image: new Icon({
              opacity: 1,
              src: require(`../../assets/poi/${typenya}a.png`),
              scale: 0.1,
              rotation: rotation,
              rotateWithView: "true"
            }),
            stroke: new Stroke({
              color: "#319FD3",
              width: 3
            }),
            fill: new Fill({
              color: "rgba(255, 255, 255, 0.6"
            }),
            text: new Text({
              font: "12px Calibri,sans-serif",
              fill: new Fill({
                color: "#000"
              }),
              offsetY: -20,
              stroke: new Stroke({
                color: "#ffff",
                width: 3
              })
            })
          });

          selected = feature;
          feature.setStyle(function(feature) {
            let textnya =
              feature.get("name") +
              " | " +
              feature.get("speed").toFixed(2) +
              " knot";
            highlightStyle.getText().setText(textnya);
            return highlightStyle;
          });
          return true;
        } else if (feature.get("geomtype") == "weather") {
          var pointHover = new Style({
            text: new Text({
              font: "12px Calibri,sans-serif",
              fill: new Fill({
                color: "#000"
              }),
              offsetY: -0,
              backgroundFill: new Fill({
                color: "#ffff"
              })
            })
          });

          selected = feature;
          feature.setStyle(function(feature) {
            let text =
              feature.get("description") +
              " | wind direction " +
              feature.get("wind_dir") +
              " | wind speed " +
              feature.get("wind_speed") +
              " | temp " +
              feature.get("temp") +
              "C";
            pointHover.getText().setText(text);
            return pointHover;
          });
          return true;
        } else if (feature.get("datetime")) {
          var pointHover = new Style({
            text: new Text({
              font: "12px Calibri,sans-serif",
              fill: new Fill({
                color: "#000"
              }),
              offsetY: -40,
              backgroundFill: new Fill({
                color: "#ffff"
              })
            })
          });
          selected = feature;
          feature.setStyle(function(feature) {
            let speed = feature.get("speedTrack");
            speed = speed * 0.1;
            let time = new Date(feature.get("datetime"));
            let text =
              "Date: " +
              moment(time).format("DD/MM/YYYY H:mm:ss") +
              " | " +
              "Longitude: " +
              feature.get("lon") +
              " Âº" +
              " | " +
              "Latitude: " +
              feature.get("lat") +
              " Âº" +
              " | " +
              "Speed: " +
              speed.toFixed(2) +
              " knot";
            pointHover.getText().setText(text);
            return pointHover;
          });
          return true;
        }
      }
    });

    this.olmap.on("singleclick", evt => {
      this.setState({ openWmsInfo: false, openBathymetry: false });
      var map = evt.map;
      var feature = map.forEachFeatureAtPixel(evt.pixel, function(feature) {
        return feature;
      });

      if (this.props.weatherChecked === true) {
        const wmsSource = new TileWMS({
          url: "https://wms.redbit.co.id/geoserver/pertamina/wms?",
          params: {
            LAYERS: "pertamina:weather_weather",
            TILED: true
          },
          serverType: "geoserver"
        });
        const url = wmsSource.getGetFeatureInfoUrl(
          evt.coordinate,
          map.getView().getResolution(),
          map.getView().getProjection(),
          {
            INFO_FORMAT: "application/json"
          }
        );
        axios
          .get(url)
          .then(response => {
            this.setState({
              openWmsInfo: true,
              wmsInfo: response.data.features[0].properties
            });
          })
          .catch(error => {
            console.log(error);
            // this.props.history.push("/pages/login#logout");
          });
      }

      if (this.props.bathymetryChecked === true) {
        const wmsSource = new TileWMS({
          url: "https://wms.redbit.co.id/geoserver/pertamina/wms?",
          params: {
            LAYERS: "pertamina:GEBCO_Ina",
            TILED: true
          },
          serverType: "geoserver"
        });
        const url = wmsSource.getGetFeatureInfoUrl(
          evt.coordinate,
          map.getView().getResolution(),
          map.getView().getProjection(),
          {
            INFO_FORMAT: "application/json"
          }
        );
        axios
          .get(url)
          .then(response => {
            this.setState({
              openBathymetry: true,
              bathymetry: response.data.features[0].properties
            });
          })
          .catch(error => {
            console.log(error);
            // this.props.history.push("/pages/login#logout");
          });
      }

      if (this.props.measureStat == false) {
        //jika ada feature
        if (feature) {
          let stateInfomap;

          //cek cluster atau tidak
          if (feature.get("features")) {
            var features = feature.get("features");
            this.olmap.removeLayer(this.state.searchPOI);
            this.olmap.removeLayer(this.state.searchSpeed);
            this.olmap.removeLayer(this.state.vesselTrack);
            this.olmap.removeLayer(this.state.layerLinesnya);
            this.olmap.removeLayer(this.state.layerPointsnya);
            this.olmap.removeLayer(this.state.layerLinesnya1);
            this.olmap.removeLayer(this.state.layerPointsnya1);
            this.olmap.removeLayer(this.state.searchFraud);
            this.olmap.removeLayer(this.state.fraudApp);
            this.props.pushRightPanel(true);
            this.props.pushPoiTarget([0, 0]);
            this.props.pushPortTarget([0, 0]);
            this.props.pushSpeedTarget([0, 0]);
            this.props.pushVesselPointTrack([0, 0]);
            this.props.pushPointShipTrack([]);
            this.props.pushShipTrack([]);
            this.props.pushShipTrack2([]);
            this.props.pushShipFraud([0, 0]);

            this.setState({
              features: features[0],
              opened: true
            });
            var coordinate = evt.coordinate;

            stateInfomap = {
              jenis: features[0].get("vesselpoint"),
              //baloonTitle: feature.get("date_created"),
              baloonTitle: moment(features[0].get("date_created")).format(
                "DD-MM-YYYY HH:mm:ss"
              ),
              hdg: features[0].get("heading"),
              typenya: features[0].get("typenya"),
              geomtype: features[0].get("geomtype"),
              course: features[0].get("course"),
              elapsed: features[0].get("elapsed"),
              heading: features[0].get("heading"),
              lat: features[0].get("lat"),
              lon: features[0].get("lon"),
              shipname: features[0].get("shipname"),
              shiptype: features[0].get("shiptype"),
              ship_id: features[0].get("ship_id"),
              speed: features[0].get("speed"),
              destination: features[0].get("destination"),
              width: features[0].get("width"),
              length: features[0].get("length"),
              dwt: features[0].get("dwt"),
              call_sign: features[0].get("call_sign"),
              rot: features[0].get("rot"),
              flag: features[0].get("flag"),
              date_created: features[0].get("date_created"),
              status_name: features[0].get("status_name"),
              type_img: features[0].get("type_img"),
              type_name: features[0].get("type_name"),
              geofenceport_status: features[0].get("geofenceport_status"),
              geofenceport_name: features[0].get("geofenceport_name"),
              id: features[0].get("id"),
              Tanggal: features[0].get("Tanggal"),
              Jam: features[0].get("Jam"),
              DateTime: features[0].get("DateTime"),
              Coordinates: features[0].get("Coordinates"),
              Lintang: features[0].get("Lintang"),
              Bujur: features[0].get("Bujur"),
              Magnitude: features[0].get("Magnitude"),
              Kedalaman: features[0].get("Kedalaman"),
              Wilayah: features[0].get("Wilayah"),
              Potensi: features[0].get("Potensi"),
              Dirasakan: features[0].get("Dirasakan"),
              Shakemap: features[0].get("Shakemap"),
              name: features[0].get("name"),
              description: features[0].get("description"),
              address: features[0].get("address"),
              gid: features[0].get("gid"),
              weather: this.state.weather,
              temp: this.state.temp,
              dimensi: features[0].get("dimensi"),
              subdimensi: features[0].get("subdimensi"),
              district: features[0].get("district"),
              subdistrict: features[0].get("subdistrict"),
              category: features[0].get("category"),
              datetime: moment(features[0].get("datetime")).format(
                "DD-MM-YYYY HH:mm:ss"
              ),
              speedTrack: features[0].get("speedTrack"),
              vessel_status: features[0].get("vessel_status"),
              vessel_container: features[0].get("vessel_container"),
              remark: features[0].get("remark"),
              ipman_container_value: features[0].get("ipman_container_value"),
              ipman_activity: features[0].get("ipman_activity"),
              ipman_plant: features[0].get("ipman_plant"),
              ipman_eta: features[0].get("ipman_eta"),
              ipman_ata: features[0].get("ipman_ata"),
              ipman_remark: features[0].get("ipman_remark"),
              ipman_container: features[0].get("ipman_container"),
              eta: features[0].get("eta"),
              source: features[0].get("source")
            };
          } else {
            if (feature.get("name") == "Line" || feature.get("name") == "asd") {
              this.olmap.removeLayer(this.state.layerPointsnya);
              this.props.pushVesselPointTrack([0, 0]);
              this.props.pushRightPanel(false);
              this.setState({
                opened: false
              });
            }

            if (feature.get("name") == "Track") {
              this.olmap.removeLayer(this.state.layerPointsnya);
              this.props.pushVesselPointTrack([0, 0]);
              this.props.pushRightPanel(true);
              this.setState({
                opened: true
              });
            }

            if (
              feature.get("geomtype") == "vessel" ||
              feature.get("geomtype") == "port" ||
              feature.get("geomtype") == "gempa" ||
              feature.get("geomtype") == "fraud"
            ) {
              this.olmap.removeLayer(this.state.searchPOI);
              this.olmap.removeLayer(this.state.searchSpeed);
              this.olmap.removeLayer(this.state.vesselTrack);
              this.olmap.removeLayer(this.state.layerLinesnya);
              this.olmap.removeLayer(this.state.layerPointsnya);
              this.olmap.removeLayer(this.state.layerLinesnya1);
              this.olmap.removeLayer(this.state.layerPointsnya1);
              this.olmap.removeLayer(this.state.searchFraud);
              this.olmap.removeLayer(this.state.fraudApp);
              this.props.pushRightPanel(true);
              this.props.pushPoiTarget([0, 0]);
              this.props.pushPortTarget([0, 0]);
              this.props.pushSpeedTarget([0, 0]);
              this.props.pushVesselPointTrack([0, 0]);
              this.props.pushPointShipTrack([]);
              this.props.pushShipTrack([]);
              this.props.pushShipTrack2([]);
              this.props.pushShipFraud([0, 0]);
            }
            this.setState({
              features: feature,
              opened: true
            });
            var coordinate = evt.coordinate;

            stateInfomap = {
              jenis: feature.get("vesselpoint"),
              //baloonTitle: feature.get("date_created"),
              baloonTitle: moment(feature.get("date_created")).format(
                "DD-MM-YYYY HH:mm:ss"
              ),
              hdg: feature.get("heading"),
              typenya: feature.get("typenya"),
              geomtype: feature.get("geomtype"),
              course: feature.get("course"),
              elapsed: feature.get("elapsed"),
              heading: feature.get("heading"),
              lat: feature.get("lat"),
              lon: feature.get("lon"),
              shipname: feature.get("shipname"),
              shiptype: feature.get("shiptype"),
              ship_id: feature.get("ship_id"),
              speed: feature.get("speed"),
              destination: feature.get("destination"),
              width: feature.get("width"),
              length: feature.get("length"),
              dwt: feature.get("dwt"),
              call_sign: feature.get("call_sign"),
              rot: feature.get("rot"),
              flag: feature.get("flag"),
              date_created: feature.get("date_created"),
              status_name: feature.get("status_name"),
              type_img: feature.get("type_img"),
              type_name: feature.get("type_name"),
              geofenceport_status: feature.get("geofenceport_status"),
              geofenceport_name: feature.get("geofenceport_name"),
              id: feature.get("id"),
              Tanggal: feature.get("Tanggal"),
              Jam: feature.get("Jam"),
              DateTime: feature.get("DateTime"),
              Coordinates: feature.get("Coordinates"),
              Lintang: feature.get("Lintang"),
              Bujur: feature.get("Bujur"),
              Magnitude: feature.get("Magnitude"),
              Kedalaman: feature.get("Kedalaman"),
              Wilayah: feature.get("Wilayah"),
              Potensi: feature.get("Potensi"),
              Dirasakan: feature.get("Dirasakan"),
              Shakemap: feature.get("Shakemap"),
              name: feature.get("name"),
              description: feature.get("description"),
              address: feature.get("address"),
              gid: feature.get("gid"),
              weather: this.state.weather,
              temp: this.state.temp,
              dimensi: feature.get("dimensi"),
              subdimensi: feature.get("subdimensi"),
              district: feature.get("district"),
              subdistrict: feature.get("subdistrict"),
              category: feature.get("category"),
              datetime: moment(feature.get("datetime")).format(
                "DD-MM-YYYY HH:mm:ss"
              ),
              speedTrack: feature.get("speedTrack"),
              vessel_status: feature.get("vessel_status"),
              vessel_container: feature.get("vessel_container"),
              remark: feature.get("remark"),
              fraudid: feature.get("fraudid"),
              idleTime: feature.get("idleTime"),
              last_gps: feature.get("last_gps"),
              last_ais: feature.get("last_ais"),
              last_cctv: feature.get("last_cctv"),
              weatherFraud: feature.get("weatherFraud"),
              windSpeedFraud: feature.get("windSpeedFraud"),
              first_recorded: feature.get("first_recorded"),
              source: feature.get("source")
            };
          }

          this.setState(stateInfomap);

          this.props.pushAllStateMapmaster(stateInfomap);

          overlay.setPosition(coordinate);
        }
      }
    });
    // end load vessel

    // tick schedule
    this.timerID = setInterval(() => this.tick(), 400000);
  }

  componentWillUnmount() {
    clearInterval(this.timerID);
  }

  addInteraction = drawType => {
    this.source = new VectorSource({ wrapX: false });
    this.vector = new VectorLayer({
      source: this.source
    });
    this.draw = new Draw({
      source: this.source,
      type: drawType,
      style: new Style({
        fill: new Fill({
          color: "rgba(255, 255, 255, 0.2)"
        }),
        stroke: new Stroke({
          color: "rgba(0, 0, 0, 0.5)",
          lineDash: [10, 10],
          width: 2
        }),
        image: new CircleStyle({
          radius: 5,
          stroke: new Stroke({
            color: "rgba(0, 0, 0, 0.7)"
          }),
          fill: new Fill({
            color: "rgba(255, 255, 255, 0.2)"
          })
        })
      })
    });
    this.drawTemp.push(this.draw);
    this.vectorTemp.push(this.vector);

    this.olmap.addInteraction(this.draw);
    this.olmap.addLayer(this.vector);

    this.draw.on(
      "drawstart",
      evt => {
        this.sketch = evt.feature;
        var tooltipCoord = evt.coordinate;

        this.sketch.getGeometry().on("change", evt => {
          var geom = evt.target;
          var output;
          if (geom instanceof Polygon) {
            output = formatLength(geom);
            this.measureTooltipElement.innerHTML = output;
            tooltipCoord = geom.getLastCoordinate();
          } else if (geom instanceof LineString) {
            output = formatLength(geom);
            let countmil = output.split(" ");

            let milspeed = countmil[0] * 0.539957;
            let message = "";

            if (this.state.speed == "") {
              message = milspeed.toFixed(2) + " nmi ";
            } else {
              let time = milspeed / this.state.speed;
              let tt = time.toFixed(2);
              let decimalTime = parseFloat(tt);
              decimalTime = decimalTime * 60 * 60;
              let hours = Math.floor(decimalTime / (60 * 60));
              decimalTime = decimalTime - hours * 60 * 60;
              let minutes = Math.floor(decimalTime / 60);
              decimalTime = decimalTime - minutes * 60;
              let seconds = Math.round(decimalTime);

              let timeDate = new Date(this.state.date_created);
              let timenya = moment(timeDate, "HH:mm:ss A")
                .add(seconds, "seconds")
                .add(minutes, "minutes")
                .add(hours, "hours")
                .format("DD-MM-YYYY HH:mm:ss");

              message =
                "Distance " +
                milspeed.toFixed(2) +
                " nmi " +
                "Speed " +
                this.state.speed +
                " knot " +
                "| ETA " +
                time.toFixed(2) +
                " hour " +
                "at " +
                timenya;
            }

            this.measureTooltipElement.innerHTML = message;
            tooltipCoord = geom.getLastCoordinate();
          } else if (geom instanceof Circle) {
            let firstCordinate = geom.getFirstCoordinate();
            let lastCordinate = geom.getLastCoordinate();

            var line = new LineString([firstCordinate, lastCordinate]);

            let output = (
              (Math.round(line.getLength() * 100) / 100) *
              0.001
            ).toFixed(2);

            if (output != 0) {
              //convert circle to polygondepok
              let coordinatecircle = transform(
                firstCordinate,
                "EPSG:3857",
                "EPSG:4326"
              );

              // let polygonnya = circleToPolygon(
              //   coordinatecircle,
              //   output * 1000,
              //   32
              // );
              //
              // this.props.pushRadiusGeom(polygonnya);

              //end convert circle to polygondepok

              this.measureTooltipElement.innerHTML =
                output + "km" + this.state.speed;
              tooltipCoord = geom.getLastCoordinate();
            }
          } else {
            return false;
          }
          this.measureTooltip.setPosition(tooltipCoord);
        });
      },
      this
    );
    this.draw.on(
      "drawend",
      // e => {
      //   console.log("draw end");
      //   this.setState({ measure: "" });
      //   var writer = new GeoJSON();
      //   var geojsonStr = writer.writeFeatures([e.feature]);
      //   //console.log(geojsonStr);
      //   this.props.pushDrawData(geojsonStr);
      // },
      e => {
        this.setState({ measure: "" });
        var writer = new GeoJSON();
        var geojsonStr = writer.writeFeatures([e.feature]);
        const a = JSON.parse(geojsonStr);
        if (a.features[0].geometry.type === "Polygon") {
          let newArr = [];
          const b = a.features[0].geometry;
          b.coordinates.map(e => {
            e.map(ee => {
              let wrapped = _(newArr).push([ee[0], ee[1]]);
              wrapped.commit();
            });
          });
          let newObj = { type: "Polygon", coordinates: [newArr] };

          this.props.pushDrawData(JSON.stringify(newObj));
          this.props.pushDrawDataAll(geojsonStr);
        } else {
          this.props.pushDrawData("-");
          this.props.pushDrawDataAll(geojsonStr);
        }
      },
      this
    );
  };

  handleClickOpen = () => {
    this.setState({ openWmsInfo: false });
  };

  handleClickBathymetry = () => {
    this.setState({ openBathymetry: false });
  };

  renderInfo = () => {
    let b = this.state.wmsInfo;

    return (
      <Table size="medium" aria-label="a dense table">
        <TableBody striped={true}>
          <TableRow>
            <TableCell component="th" scope="row">
              {" "}
              <small style={{ fontSize: "14px" }}>Description</small>
            </TableCell>
            <TableCell align="right">
              <small style={{ fontSize: "14px" }}>{b.description} </small>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              {" "}
              <small style={{ fontSize: "14px" }}>Wind Direction</small>
            </TableCell>
            <TableCell align="right">
              <small style={{ fontSize: "14px" }}>{b.wind_dir}</small>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              {" "}
              <small style={{ fontSize: "14px" }}>Wind Speed</small>
            </TableCell>
            <TableCell align="right">
              <small style={{ fontSize: "14px" }}>{b.wind_speed}</small>
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell component="th" scope="row">
              {" "}
              <small style={{ fontSize: "14px" }}>Temperature </small>
            </TableCell>
            <TableCell align="right">
              <small style={{ fontSize: "14px" }}>{b.temp} C </small>
            </TableCell>
          </TableRow>
          <br />
        </TableBody>
      </Table>
    );
  };

  renderBathymetry = () => {
    let c = this.state.bathymetry;
    return (
      <Table size="medium" aria-label="a dense table">
        <TableBody striped={true}>
          <TableRow>
            <TableCell component="th" scope="row">
              {" "}
              <small style={{ fontSize: "14px" }}>Index</small>
            </TableCell>
            <TableCell align="right">
              <small style={{ fontSize: "14px" }}>{c.GRAY_INDEX} </small>
            </TableCell>
          </TableRow>
          <br />
        </TableBody>
      </Table>
    );
  };

  renderWmsInfo = () => {
    const { classes } = this.props;
    return (
      <div>
        <Dialog
          onClose={this.handleClickOpen}
          aria-labelledby="wms-info"
          open={this.state.openWmsInfo}
          //fullWidth={true}
          scroll="paper"
          maxWidth="lg"
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
          >
            <Button
              justIcon
              className={classes.modalCloseButton}
              key="close"
              aria-label="Close"
              color="transparent"
              onClick={() => this.setState({ openWmsInfo: false })}
            >
              <Close className={classes.modalClose} />
            </Button>
            <h4 className={classes.modalTitle}>Information</h4>
          </DialogTitle>
          <DialogContent
            id="modal-slide-description"
            className={classes.modalBody}
            style={{ height: "300px" }}
          >
            {this.renderInfo()}
          </DialogContent>
        </Dialog>
      </div>
    );
  };

  renderBathymetryInfo = () => {
    const { classes } = this.props;
    return (
      <div>
        <Dialog
          onClose={this.handleClickBathymetry}
          aria-labelledby="wms-info"
          open={this.state.openBathymetry}
          //fullWidth={true}
          scroll="paper"
          maxWidth="lg"
        >
          <DialogTitle
            id="classic-modal-slide-title"
            disableTypography
            className={classes.modalHeader}
          >
            <Button
              justIcon
              className={classes.modalCloseButton}
              key="close"
              aria-label="Close"
              color="transparent"
              onClick={() => this.setState({ openBathymetry: false })}
            >
              <Close className={classes.modalClose} />
            </Button>
            <h4 className={classes.modalTitle}>Information</h4>
          </DialogTitle>
          <DialogContent
            id="modal-slide-description"
            className={classes.modalBody}
            style={{ height: "300px" }}
          >
            {this.renderBathymetry()}
          </DialogContent>
        </Dialog>
      </div>
    );
  };

  render() {
    return (
      <div id="map" style={{ height: "88%", width: "100%", position: "fixed" }}>
        <MousePositionInfo />
        {/*<Legend />*/}
        <Legend />
        <LegendLayer />
        <div
          hidden={
            this.state.name === "Line"
              ? true
              : false || this.state.name === "asd"
                ? true
                : false
          }
          id="popup"
          className="ol-popup"
        >
          <div
            style={{
              backgroundColor: "#192964"
            }}
          >
            <a
              href=""
              style={{ color: "white" }}
              id="popup-closer"
              className="ol-popup-closer"
            />
          </div>
          <div id="popupContent">
            <div
              style={{
                backgroundColor: "#192964"
              }}
            >
              <div
                hidden={this.state.geomtype === "vessel" ? false : true}
                style={{ padding: "10px" }}
              >
                <font color="white">
                  <b>{this.state.baloonTitle}</b>
                </font>
              </div>
              <div
                hidden={this.state.geomtype === "port" ? false : true}
                style={{ padding: "10px" }}
              >
                <font color="white">
                  <b>{this.state.name}</b>
                </font>
              </div>
              <div
                hidden={this.state.geomtype === "gempa" ? false : true}
                style={{ padding: "10px" }}
              >
                <font color="white">
                  <b>{this.state.DateTime}</b>
                </font>
              </div>
              <div
                hidden={this.state.name === "Track" ? false : true}
                style={{ padding: "10px" }}
              >
                <font color="white">
                  <b>{this.state.datetime}</b>
                </font>
              </div>
              <div
                hidden={this.state.geomtype === "fraud" ? false : true}
                style={{ padding: "10px" }}
              >
                <font color="white">
                  <b>{this.state.date_created}</b>
                </font>
              </div>
            </div>
          </div>
          {this.renderWmsInfo()}
          {this.renderBathymetryInfo()}
        </div>
        <div id="measuretooltip">measure</div>
      </div>
    );
  }
}

Mapmaster.propTypes = {
  classes: PropTypes.object.isRequired,
  center: PropTypes.array,
  port: PropTypes.array,
  zoom: PropTypes.number,
  pushShipFinder: PropTypes.array,
  pushLoader: PropTypes.bool,
  pushPoiPasenger: PropTypes.func,
  pushPoiContent: PropTypes.func,
  measureStat: PropTypes.bool,
  pushLonlatMouse: PropTypes.array,
  pushBottomPanel: PropTypes.bool,
  drawType: PropTypes.string,
  pushDrawData: PropTypes.object,
  pushDrawDataAll: PropTypes.object,
  pushPoiTarget: PropTypes.object,
  pushSpeedTarget: PropTypes.object,
  pushPortTarget: PropTypes.object,
  pushVesselPointTrack: PropTypes.object,
  zoneTarget: PropTypes.string,
  earthQuake: PropTypes.object,
  pushPointShipTrack: PropTypes.array,
  pushShipTrack: PropTypes.array,
  pushShipTrack2: PropTypes.array,
  pushVesselPtmSelected: PropTypes.bool,
  pushRightPanel: PropTypes.bool,
  pushShipFraud: PropTypes.object
};

function mapStateToProps(state) {
  return {
    blocking: state.loader,
    basemapAsli: state.basemapAsli,
    vesselSelected: state.vesselSelected,
    measureStat: state.measureStat,
    drawType: state.drawType,
    poiTarget: state.poiTarget,
    speedTarget: state.speedTarget,
    portTarget: state.portTarget,
    layerAdd: state.layerAdd,
    poiSelected: state.poiSelected,
    pushPoiSelected: PropTypes.array,
    zoneTarget: state.zoneTarget,
    activeDrawing: state.activeDrawing,
    earthQuake: state.earthQuake,
    vesselPtmChecked: state.vesselPtmChecked,
    pointShipTrack: state.pointShipTrack,
    shipTrack: state.shipTrack,
    shipTrack2: state.shipTrack2,
    shipFraud: state.shipFraud,
    sourceAis: state.sourceAis,
    vesselPointTrack: state.vesselPointTrack,
    weatherChecked: state.weatherChecked,
    bathymetryChecked: state.bathymetryChecked,
    filter: state.filter
  };
}

export default withRouter(
  connect(
    mapStateToProps,
    {
      pushLoader,
      pushDrawData,
      pushDrawDataAll,
      pushLonlatMouse,
      pushRadiusGeom,
      pushPoiSelected,
      pushZonaTarget,
      pushActiveDrawing,
      pushVesselPtmSelected,
      pushPoiTarget,
      pushPortTarget,
      pushVesselPointTrack,
      pushPointShipTrack,
      pushAllStateMapmaster,
      pushShipTrack,
      pushShipTrack2,
      pushRightPanel,
      pushShipFraud,
      pushSpeedTarget
    }
  )(withStyles(styles)(Mapmaster))
);
